module.exports = __webpack_public_path__ + "static/img/03.afed40d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/03.jpg
// module id = 442
// module chunks = 1